import { render } from "./workboard.vue?vue&type=template&id=e4b44bea&scoped=true"
import script from "./workboard.vue?vue&type=script&lang=js"
export * from "./workboard.vue?vue&type=script&lang=js"

import "./workboard.vue?vue&type=style&index=0&id=e4b44bea&lang=css"
import "./workboard.vue?vue&type=style&index=1&id=e4b44bea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b44bea"]])

export default __exports__